import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

export interface IDynamicForm {
  form: FormGroup<any>;
}

@Injectable({
  providedIn: 'root',
})
export class DynamicFormsService {
  activeForms: IDynamicForm[] = [];

  addForm(form: IDynamicForm) {
    this.activeForms.push(form);
  }

  removeForm(form: IDynamicForm) {
    this.activeForms = this.activeForms.filter((f) => f !== form);
  }

  setApiErrors(errors: Record<string, string[]>) {
    this.activeForms.forEach(({ form }) => {
      Object.entries(errors).forEach(([key, value]) => {
        form.get(key)?.setErrors({
          serverError: {
            message:
              value[0] + (value.length > 1 ? ` (+${value.length - 1})` : ''),
          },
        });
      });
    });
  }
}
